import React from "react";
import { connect } from "react-redux";
import { InfoBar } from "ctia-ui";
import { getModelName } from "helpers/RequestHelper";

const TestResultsInfoBarBLC = ({ request }) => {
  const reqInfo = [
    {
      key: "Vendor",
      value: request.vendor
    },
    {
      key: "Model Name/Number",
      value: getModelName(request)
    },
    {
      key: "Test",
      value: "Battery Life"
    }
  ];

  return <InfoBar show={true} data={reqInfo} />;
};

function mapStateToProps({ request }) {
  return { request };
}

export default connect(mapStateToProps)(TestResultsInfoBarBLC);
